<div class="aag-list-item" role="listitem">
  <finder-font-icon class="list-icon" [name]="this.icon" size="s"></finder-font-icon>
  <ng-content></ng-content>
</div>
